<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="container_check version_2" name="ortak" style="padding-top: 8px; padding-left: 35px">
            {{ $t('Ortağınız var mı') }}
            <input
              :checked="isPartnershipSelected"
              id="partner-select"
              @click="checkPartnership"
              name="foreign-citizen"
              type="checkbox"
              value="true"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>

    <div v-if="isPartnershipSelected">
      <form id="formShareholder" data-vv-scope="formShareholder">
        <div v-for="(partnership, index) in partnershipDetails" :key="index" class="partner-borders">
          <div class="row">
            <div class="col-lg-9">
              <div class="row">
                <div class="col-md-6">
                  <h3 class="main_question">{{ $t('Ad') }}</h3>
                  <InputField
                    v-model="partnership.name"
                    :name="'partnerName' + index"
                    v-tippy="$t('Ortak Ad Tooltip')"
                    :placeholder="$t('Ad')"
                    v-validate="'required'"
                    :error="errors.first('formShareholder.partnerName' + index)"
                    :validateFields="scopeFields['$formShareholder']['partnerName' + index]"
                  />
                </div>
                <div class="col-md-6">
                  <h3 class="main_question">{{ $t('Soyad') }}</h3>
                  <InputField
                    v-model="partnership.surname"
                    :name="'partnerSurname' + index"
                    v-tippy="$t('Ortak Soyad Tooltip')"
                    :placeholder="$t('Soyad')"
                    v-validate="'required'"
                    :error="errors.first('formShareholder.partnerSurname' + index)"
                    :validateFields="scopeFields['$formShareholder']['partnerSurname' + index]"
                  />
                </div>
                <div class="col-md-6">
                  <h3 class="main_question">{{ $t('Cep Telefonu Numarası') }}</h3>
                  <div class="form-group">
                    <vue-tel-input
                      id="phone-mask"
                      @validate="partnershipPhoneValidate(index, ...arguments)"
                      :defaultCountry="defaultMobileCountry"
                      v-model="partnership.mobile"
                      class="form-control"
                      :class="partnership.mobile && !validTelsArray[index] ? 'is-invalid' : ''"
                      :input-options="{ placeholder: $t('Cep Telefonu Numarası') }"
                      validCharactersOnly
                    ></vue-tel-input>
                    <span v-show="partnership.mobile && !validTelsArray[index]" class="invalid-feedback">{{
                      $t('AlertMessages.Girdiğiniz telefon numarası geçerli değil')
                    }}</span>
                    <error-box field="mobile" />
                  </div>
                </div>
                <div class="col-md-6 form-group">
                  <h3 class="main_question">{{ $t('Yüzde') }}</h3>
                  <div class="input-group">
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                    <input
                      v-tippy="$t('Ortak yüzdelik Tooltip')"
                      :name="'partnerPercentage' + index"
                      type="number"
                      class="form-control percent"
                      :class="{ 'is-invalid': errors.first('formShareholder.partnerPercentage' + index) }"
                      v-validate="'required|min_value:1|percentLimit:' + percentArray[index] + ''"
                      v-model="partnership.percent"
                      @input="checkInput(index)"
                      :placeholder="$t('Yüzde')"
                    />
                  </div>
                  <span
                    v-show="errors.first('formShareholder.partnerPercentage' + index)"
                    class="show-invalid invalid-feedback"
                    >{{ errors.first('formShareholder.partnerPercentage' + index) }}</span
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-3 delete-grid my-auto">
              <button
                class="btn btn-danger w-100 delete"
                name="add"
                type="button"
                @click="deletePartnershipField(index)"
              >
                {{ $t('Sil') }}
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="row" style="margin-top: 15px; margin-bottom: 15px">
        <div class="col-lg-5 col-md-4 col-sm-4 col-12 first-button-group">
          <button class="backward w-100 h-100" name="add" type="button" @click="addNewPartnershipField()">
            {{ $t('Ekle') }}
          </button>
        </div>
      </div>
    </div>
    <UncheckConfirmationModal
      :modalHeader="$t('İşbirlikleriniz silinecek')"
      :modalText="$t('İşbirlikleriniz silinecek kabul ediyor musunuz')"
      ref="confirmationModal"
      @confirm-delete="deleteAllPartnerships()"
    />
  </div>
</template>

<script>
import UncheckConfirmationModal from './modals/UncheckConfirmationModal';
import InputField from './InputField.vue';
export default {
  props: {
    mainPartnershipDetails: Array,
    mainValidTelsArray: Array,
    nationId: Number,
    isPartnershipSelected: Boolean,
  },
  data() {
    return {
      partnershipValues: {
        name: null,
        surname: null,
        mobile: null,
        percent: null,
      },
      defaultMobileCountry: 'US',
      percentArray: [99],
    };
  },
  created() {
    this.$validator = this.$parent.$validator;
    if (this.partnershipDetails && this.partnershipDetails[0].name) {
      this.$emit('update:isPartnershipSelected', true);
    }
    this.calculateMaxPercent();

    if (this.nationId === 2) {
      this.defaultMobileCountry = 'US';
    } else if (this.nationId === 3) {
      this.defaultMobileCountry = 'GB';
    } else {
      this.defaultMobileCountry = 'EE';
    }
  },
  computed: {
    partnershipDetails: {
      get: function () {
        return this.mainPartnershipDetails;
      },
      set: function (newValue) {
        this.$emit('update:mainPartnershipDetails', newValue);
      },
    },
    validTelsArray: {
      get: function () {
        return this.mainValidTelsArray;
      },
      set: function (newValue) {
        this.$emit('update:mainValidTelsArray', newValue);
      },
    },

    scopeFields() {
      if (Object.keys(this.fields).length !== 0) {
        return { ...{ $formShareholder: {} }, ...this.fields };
      }
      return {
        $formShareholder: {},
      };
    },
  },
  methods: {
    checkInput(index) {
      if (this.partnershipDetails[index].percent > this.percentArray[index]) {
        if (this.percentArray[index] >= 0) {
          this.partnershipDetails[index].percent = this.percentArray[index];
        } else {
          this.partnershipDetails[index].percent = 0;
        }
      }
      this.calculateMaxPercent(index);
    },
    checkNullCountsValid() {
      const count = this.validTelsArray.filter(Boolean).length;
      let isNullCountsValid;

      if (this.isPartnershipSelected && count !== this.validTelsArray.length) {
        isNullCountsValid = false;
      } else {
        isNullCountsValid = true;
      }
      return isNullCountsValid;
    },

    partnershipPhoneValidate(index, event) {
      this.validTelsArray.splice(index, 1, event.valid);
    },
    checkPartnership(e) {
      if (!e.target.checked) {
        const element = this.$refs.confirmationModal.$el;
        $(element).modal('show');
        e.preventDefault();
      } else {
        this.$emit('update:isPartnershipSelected', true);
      }
    },
    deletePartnershipField(id) {
      this.partnershipDetails.splice(id, 1);
      this.validTelsArray.splice(id, 1);
      if (id !== 0) {
        this.percentArray.splice(id, 1);
      }

      this.calculateMaxPercent(id);

      if (!this.partnershipDetails.length) {
        this.$emit('update:isPartnershipSelected', false);
        this.partnershipDetails.push(Object.assign({}, this.partnershipValues));
      }
      this.$nextTick(() => {
        this.$validator.reset({ vm: this, scope: 'formShareholder' });
      });
    },
    addNewPercent() {
      const maxLimit =
        this.percentArray[this.percentArray.length - 1] -
        this.partnershipDetails[this.partnershipDetails.length - 2].percent;
      this.percentArray.push(maxLimit);
    },
    addNewPartnershipField() {
      const count = this.validTelsArray.filter(Boolean).length;
      if (count === this.validTelsArray.length) {
        const copy = Object.assign({}, this.partnershipValues);
        this.partnershipDetails.push(copy);
        this.addNewPercent();
      } else {
        window.Vue.$toasted.error(this.$t('AlertMessages.Lütfen geçerli bir telefon numarası girin'));
      }
    },
    calculateMaxPercent(detailIndex) {
      this.percentArray.splice(1, this.partnershipDetails.length);
      for (let index = 0; index < this.partnershipDetails.length - 1; index++) {
        const maxLimit = this.percentArray[index] - this.partnershipDetails[index].percent;
        this.percentArray.push(maxLimit);
      }
    },
    deleteAllPartnerships() {
      this.$emit('update:isPartnershipSelected', false);
      document.getElementById('partner-select').checked = false;
      this.partnershipDetails.splice(0, this.partnershipDetails.length);
      this.percentArray = [99];
      this.validTelsArray = [];
      this.partnershipDetails.push(Object.assign({}, this.partnershipValues));
    },
  },
  components: {
    UncheckConfirmationModal,
    InputField,
  },
};
</script>
